import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { StaticDataApiService } from 'src/helper/static-data.service';

@Component({
  selector: 'app-spanish-itim-book',
  templateUrl: './spanish-itim-book.component.html',
  styleUrls: ['./spanish-itim-book.component.css']
})
export class SpanishItimBookComponent implements OnInit {

  constructor(private route : ActivatedRoute,private staticdata : StaticDataApiService) { }
  booklinkdetails:any;
  bookdetails:any;
  ngOnInit(): void {
    this.route.params.subscribe((param: Params) => {
          
      this.booklinkdetails = this.staticdata.getspanishBookByModule('spanish-translations',param['id']);
      this.bookdetails = this.booklinkdetails?.bookDetails;
    });
  }


}
